import { render, staticRenderFns } from "./Pagenation.vue?vue&type=template&id=6a24b8a3&scoped=true"
import script from "./Pagenation.vue?vue&type=script&lang=js"
export * from "./Pagenation.vue?vue&type=script&lang=js"
import style0 from "./Pagenation.vue?vue&type=style&index=0&id=6a24b8a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24b8a3",
  null
  
)

export default component.exports